module.exports = __webpack_public_path__ + "media/images/logos/cnrs-ee7a9ce8756bfdffae6394ab9be34270.png";